import { Injectable } from '@angular/core';
import { AccountService } from 'app/core/auth/account.service';
import { AuthServerProvider, LOGOUT_URL } from 'app/core/auth/auth-jwt.service';
import { Account } from 'app/core/user/account.model';
import { Observable } from 'rxjs';
import { Login } from './login.model';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/app.state';
import {
  ResetSortFilterLCDLayoutEditorStateAction,
  ResetSortFilterLEDLayoutEditorStateAction,
  ResetSortFilterStateAction,
  ResetSortFilterUserManagerStateAction
} from 'app/ngrx-component-state-management/component-state.action';
import { Common } from 'app/model/entity/common';
import { DataService } from 'app/service/data.service';
import { CommonService } from 'app/service/common.service';
import { SessionService } from 'app/service/session.service';

@Injectable({ providedIn: 'root' })
export class LoginService {
  commonObject: Common;

  constructor(
    private accountService: AccountService,
    private authServerProvider: AuthServerProvider,
    public readonly store: Store<AppState>,
    private dataService: DataService,
    private commonService: CommonService,
    private sessionService: SessionService
  ) {
    this.commonObject = this.commonService.getCommonObject();
  }

  login(credentials: Login): Observable<Account | null> {
    return this.authServerProvider.login(credentials).pipe();
  }

  logoutUrl(): string {
    return LOGOUT_URL;
  }

  logoutInClient(): void {
    this.accountService.authenticate(null);
  }

  logout() {
    this.sessionService.deactivateSessionById().subscribe(
      response => {
        this.store.dispatch(new ResetSortFilterStateAction());
        this.store.dispatch(new ResetSortFilterUserManagerStateAction());
        this.store.dispatch(new ResetSortFilterLCDLayoutEditorStateAction());
        this.store.dispatch(new ResetSortFilterLEDLayoutEditorStateAction());

        this.dataService.sendData(['userName', '']);
        this.dataService.sendData(['projectName', '']);
        sessionStorage.clear();
        this.clearAllCookies();
      },
      error => {
        this.store.dispatch(new ResetSortFilterStateAction());
        this.store.dispatch(new ResetSortFilterUserManagerStateAction());
        this.store.dispatch(new ResetSortFilterLCDLayoutEditorStateAction());
        this.store.dispatch(new ResetSortFilterLEDLayoutEditorStateAction());

        this.dataService.sendData(['userName', '']);
        this.dataService.sendData(['projectName', '']);
        sessionStorage.clear();
        this.clearAllCookies();
      }
    );
  }

  /**
   * clearAllCookies
   */
  clearAllCookies() {
    document.cookie.split(';').forEach(function(cookie) {
      const name = cookie.trim().split('=')[0];
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    });
  }

  /**
   * redirectCognitoLogin
   * @param data
   * @param params
   */
  redirectCognitoLogin(data: any, params?: any) {
    (window as any).skipBeforeUnload = true;
    (window as any).forceLogout = true;
    window.onbeforeunload = null;

    sessionStorage.clear();
    this.clearAllCookies();
    const domain = params ? data.cognitoUserpoolDomain : data.dataConfigCognito.cognitoUserpoolDomain;
    const queryString = params ? params.toString() : data.urlSearchParams.toString();
    window.location.replace(`${domain}/login?${queryString}`);
  }

  /**
   * cognitoLogout
   * @param params
   * @returns
   */
  cognitoLogout(params: any) {
    const urlDomain = params.dataConfigCognito.cognitoUserpoolDomain;
    const clientId = params.dataConfigCognito.clientId;
    const logout_Uri = `${urlDomain}/login?${params.urlSearchParams.toString()}`;
    const url = `${urlDomain}/logout?client_id=${clientId}&logout_uri=${logout_Uri}`;
    sessionStorage.clear();
    this.clearAllCookies();
    window.location.href = url;
  }
}
